import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  constructor() {
  }

  cacheResponse(key: any, dataToCache: any) {
    const stringData = JSON.stringify(dataToCache);
    localStorage.setItem(key, stringData);
  }

  retrieveParsedResponse(key: any) {
    if (key) {
      const retrievedData: any = localStorage.getItem(key);
      return JSON.parse(retrievedData);
    }
    return null;
  }

  retrieveStringifyResponse(key: any) {
    if (key) {
      return localStorage.getItem(key);
    }
    return null;
  }

}
